// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"83e7fd3c","453":"1ea279c0","455":"5db07e07","838":"0fe0569d"}[chunkId] + ".chunk.js";
};